/*
  Softy image reveal — zoom-out on scroll into view.

  Finds every content image on the page, holds it slightly zoomed in
  (see softy-image-reveal.css) and releases it to true size the first
  time it scrolls into view. Runs once per image; images already on
  screen at load settle in on the first frame.

  Runs regardless of the OS reduce-motion setting, by design.

  Decorative and already-animated imagery is skipped: header/footer
  chrome, icons, shape decor and stickers, flipbook frames, and images
  inside Dawn's own zoom-in / ambient wrappers.
*/
(function () {
  'use strict';

  var ATTR = 'data-sh-reveal';

  var SKIP =
    'header, footer, .sh-header, .sh-footer, .shopify-section-header, .shopify-section-footer, ' +
    '.sh-decor, .sh-decor-host > .sh-decor, .sh-sticker, [class*="sticker"], ' +
    '.icon, .icon-wrap, .svg-wrapper, .sh-icon-circle, ' +
    '.sh-fb__frame, .sh-vt__frame, ' +
    '.animate--zoom-in, .animate--ambient, .animate--fixed, ' +
    '.cart-drawer, .quick-add-modal, .product-popup-modal, .modal__content, ' +
    'noscript, template, [data-sh-no-reveal]';

  var observer = null;

  function eligible(img) {
    if (img.hasAttribute(ATTR)) return false;
    if (img.closest(SKIP)) return false;
    // Tiny raster assets are icons or badges, not photography.
    var w = img.getAttribute('width');
    var h = img.getAttribute('height');
    if ((w && Number(w) < 120) || (h && Number(h) < 120)) return false;
    return true;
  }

  function reveal(img) {
    img.setAttribute(ATTR, 'in');
  }

  function loaded(img) {
    return img.complete && img.naturalWidth > 0;
  }

  // Lazy images enter the viewport before their bytes arrive. Holding
  // the reveal until the photo has painted keeps the zoom-out visible
  // instead of playing out on an empty box.
  function revealWhenLoaded(img) {
    if (loaded(img)) {
      reveal(img);
      return;
    }
    var done = function () {
      img.removeEventListener('load', done);
      img.removeEventListener('error', done);
      window.requestAnimationFrame(function () { reveal(img); });
    };
    img.addEventListener('load', done);
    img.addEventListener('error', done);
  }

  function onIntersect(entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      observer.unobserve(entry.target);
      revealWhenLoaded(entry.target);
    });
  }

  function collect(scope) {
    var imgs = (scope || document).querySelectorAll('img:not([' + ATTR + '])');
    imgs.forEach(function (img) {
      if (!eligible(img)) return;
      img.setAttribute(ATTR, '');
      observer.observe(img);
    });
  }

  function init(scope) {
    if (!('IntersectionObserver' in window)) return;
    if (window.Shopify && window.Shopify.designMode) return;

    if (!observer) {
      observer = new IntersectionObserver(onIntersect, {
        // Start the zoom-out just before the image's top edge clears the fold.
        rootMargin: '0px 0px -8% 0px',
        threshold: 0.01,
      });
    }
    collect(scope);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }

  // Images injected later (rail pagination, facets, quick-add, etc.).
  var pending = false;
  new MutationObserver(function () {
    if (pending || !observer) return;
    pending = true;
    window.requestAnimationFrame(function () {
      pending = false;
      collect();
    });
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
